"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.browsers = void 0;
/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line no-shadow
var browsers;
(function (browsers) {
    browsers["BLUEFY"] = "Bluefy";
    browsers["CONNECT_BROWSER"] = "ConnectBrowser";
    browsers["BAT_BLE_BROWSER"] = "BLE Browser";
})(browsers = exports.browsers || (exports.browsers = {}));
